/**
 * @file 颜色变量 web 版本
 */
import { getBrandColors } from './brand-colors';
export { backgroundColors, borderColors, dividerColors, statusColors, palette, getPaletteColorByIndex, } from './colors.native';
/**
 * 字体颜色
 */
export const getTextColors = (themeColor) => {
    const brandColors = getBrandColors(themeColor);
    const defaults = {
        /**
         * 白色
         */
        _0: '#fff',
        /**
         * 与主色对应的文字色
         */
        brand: brandColors.text0,
        /**
         * 标题, 主要正文
         */
        _1: 'rgba(6, 12, 25, 0.85)',
        /**
         * 次要正文, 文字按钮
         */
        _2: 'rgba(6, 12, 25, 0.65)',
        /**
         * 页面内的注释信息
         */
        _3: 'rgba(6, 12, 25, 0.45)',
        /**
         * 控件内的占位信息，禁用状态控件的文字
         */
        _4: 'rgba(6, 12, 25, 0.25)',
    };
    return defaults;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbG9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUVILE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQTtBQUUvQyxPQUFPLEVBQ0wsZ0JBQWdCLEVBQ2hCLFlBQVksRUFDWixhQUFhLEVBQ2IsWUFBWSxFQUNaLE9BQU8sRUFDUCxzQkFBc0IsR0FDdkIsTUFBTSxpQkFBaUIsQ0FBQTtBQUV4Qjs7R0FFRztBQUNILE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxDQUFDLFVBQWtCLEVBQUUsRUFBRTtJQUNsRCxNQUFNLFdBQVcsR0FBRyxjQUFjLENBQUMsVUFBVSxDQUFDLENBQUE7SUFFOUMsTUFBTSxRQUFRLEdBQUc7UUFDZjs7V0FFRztRQUNILEVBQUUsRUFBRSxNQUFNO1FBQ1Y7O1dBRUc7UUFDSCxLQUFLLEVBQUUsV0FBVyxDQUFDLEtBQUs7UUFDeEI7O1dBRUc7UUFDSCxFQUFFLEVBQUUsdUJBQXVCO1FBQzNCOztXQUVHO1FBQ0gsRUFBRSxFQUFFLHVCQUF1QjtRQUMzQjs7V0FFRztRQUNILEVBQUUsRUFBRSx1QkFBdUI7UUFDM0I7O1dBRUc7UUFDSCxFQUFFLEVBQUUsdUJBQXVCO0tBQ25CLENBQUE7SUFFVixPQUFPLFFBQVEsQ0FBQTtBQUNqQixDQUFDLENBQUEifQ==